import { IHeaderPopover } from "@ryde/controls";
import { ISortableCell } from "@ryde/shared";

import { HeaderCellSortableReports } from "./header.cell.sortable.reports";

export const CellReportsSortable = ({
  children,
  fieldNameResolved,
  groupingDisabled,
  sortingDisabled,
  isHiddenFromView,
}: ISortableCell): JSX.Element => {
  const cellProps: IHeaderPopover = {
    fieldNameResolved,
    groupingDisabled,
    sortingDisabled,
    isHiddenFromView,
  };

  return (
    <HeaderCellSortableReports {...cellProps}>
      {children}
    </HeaderCellSortableReports>
  );
};
